import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";

import CustomizableTicketingImg from "../../../../Svg/newCustomizableTicketing.svg";
// import AnalyticsInsightsImg from "../../../../Svg/newAnalytics.svg";
import SwiftValImg from "../../../../Svg/newValidateTickets.svg";
// import ManageEventsOnGoImg from "../../../../Svg/newManageEvents.svg";

const features = [
  {
    title: "Customizable Ticketing",
    description:
      "We share common trends and strategies for improving your rental income and making sure you stay in high demand.",
    img: CustomizableTicketingImg,
    reverse: false,
  },
  // {
  //   title: "Analytics & Insights",
  //   description:
  //     "Gain real-time data and valuable insights to make informed decisions, track performance, and optimize your event for success.",
  //   img: AnalyticsInsightsImg,
  //   reverse: true,
  // },
  // {
  //   title: "Swiftly Validate Tickets",
  //   description:
  //     "Seamlessly scan and verify tickets in seconds, reducing wait times and ensuring a smooth check-in experience.",
  //   img: SwiftValImg,
  //   reverse: false,
  // },
  // {
  //   title: "Create Tickets & Manage Events on the Go!",
  //   description:
  //     "Effortlessly create tickets, manage events, and keep everything on track—all from the convenience of your smartphone.",
  //   img: ManageEventsOnGoImg,
  //   reverse: true,
  // },
];

const SmartFeatures = () => {
  return (
    <Container maxWidth="lg">
      <Typography
        variant="h4"
        textAlign="center"
        component={motion.div}
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        sx={styles.title}
      >
        Smart Features for{" "}
        <span style={{ color: "#535353" }} className="count-shine">
          Seamless
        </span>{" "}
        Ticketing
      </Typography>

      <Grid
        container
        spacing={5}
        alignItems="center"
        justifyContent="center"
        sx={{ mt: 4 }}
      >
        {features.map((feature, index) => (
          <Grid
            container
            item
            xs={12}
            spacing={4}
            alignItems="center"
            justifyContent="center"
            flexDirection={{
              xs: "column-reverse",
              md: feature.reverse ? "row-reverse" : "row",
            }}
            key={index}
            component={motion.div}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            viewport={{ once: true }}
            sx={styles.featureRow}
          >
            {/* Image Section with Hover Animation */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{ textAlign: "center", position: "relative", mx: "auto" }}
            >
              <motion.img
                src={feature.img}
                alt={feature.title}
                style={{ maxWidth: "100%", cursor: "pointer" }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ duration: 0.3 }}
              />
            </Grid>

            {/* Text Section with Hover Effect */}
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                textAlign: { xs: "center", md: "left" },
                mx: "auto",
              }}
              component={motion.div}
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
            >
              <Typography
                variant="h6"
                fontWeight={700}
                gutterBottom
                // sx={{ marginRight: "-80px" }}
                component={motion.div}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
                viewport={{ once: true }}
              >
                {feature.title}
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ mb: 2, textAlign: {xs: "center", md: "justify"}, hyphens: "auto" }}
                component={motion.div}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
              >
                {feature.description}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default SmartFeatures;

const styles = {
  title: {
    fontWeight: 700,
    // fontSize: { xs: "2rem", md: "2.5rem" },
    fontSize: { xs: 24, sm: 32, md: 40 },
    mb: 3,
  },
  featureRow: {
    "&:hover": {
      transform: "translateY(-5px)",
      transition: "all 0.3s ease",
    },
  },
};
